import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
// Bug 41466
// if a user types in a non-uppercase client code in the browser,
// this guard will detect it, correct the casing, and reroute appropriately.
// console.log calls intentially left in to help debug
// any routing issues that may occur from this logic.
export class ClientCodeCasingGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._isBadClientCodeCasing(route)) {
      return this._redirectToCorrectRoute(route);
    }

    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._isBadClientCodeCasing(childRoute)) {
      return this._redirectToCorrectRoute(childRoute);
    }

    return true;
  }

  private _isBadClientCodeCasing(route: ActivatedRouteSnapshot) {
    let clientCode = route.paramMap.get('client_code');

    if (!clientCode) return false;

    if (!/^([\w\d]){6}$/.test(clientCode)) {
      console.log('invalid client code format in route. rerouting to home.');
      this.router.navigate(['/']);
      return false;
    }

    return clientCode != clientCode.toUpperCase();
  }

  private _redirectToCorrectRoute(route: ActivatedRouteSnapshot) {
    let clientCode = route.paramMap.get('client_code');

    // update only the url segment for :client_code
    // route.routeConfig.path example: client/:client_code
    const routeConfig = route.routeConfig.path.split('/');

    // childRoute.url is UrlSegment[]. [{"path":"client"},{"path":"abc123"]
    const segments = [...route.url.map(x => x.path)];

    // this could be child route (from canActivateChild).
    // traverse up the tree & find any parent routes.
    // combine them to get the full path config
    let parent = route.parent;
    while (parent?.routeConfig?.path) {
      routeConfig.unshift(...route.parent.routeConfig.path.split('/'));
      segments.unshift(...parent.url.map(x => x.path));
      parent = parent?.parent;
    }

    const segmentIdx = routeConfig.indexOf(':client_code');
    if (segmentIdx == -1) return true; // safeguard, but should not be happening in practice

    // find the client code segment based on the routeConfig segmentIdx
    segments[segmentIdx] = clientCode.toUpperCase();

    // reconstruct the URL with uppercase client code
    // join the URLSegments back together
    const url = `${segments.map(segment => `/${segment}`).join('')}`;

    console.log('client code route parameter was not uppercase. rerouting now.');
    this.router.navigate([url], { fragment: route.fragment });
    return false;
  }
}
